'use client';
import { getDotcmsImageURL } from '@/app/utils/getDotcmsImageURL';
import { Button } from '@headlessui/react';
import { gsap } from 'gsap';
import Image from 'next/image';
import { useEffect, useRef } from 'react';

const greenSelectorAnimationDuration = 3;

const animateBrandLogo = (timelineRef, logosRef, i, setActiveIndex) => {
    requestAnimationFrame(() => {
        const targetElement = logosRef.current?.children[i]?.children[1];
        if (!targetElement) return;

        timelineRef.current.clear();
        timelineRef.current.set(targetElement, {
            scaleX: 0
        });
        timelineRef.current.to(targetElement, {
            scaleX: 1,
            duration: greenSelectorAnimationDuration * 0.2
        });
        setActiveIndex(i);
    });
};

export const LogoImages = ({
    logos = [],
    logosRef,
    activeIndex,
    setActiveIndex,
    sortedOpacities,
    timelineRef
}) => {
    const borderTimelineRef = useRef(null);

    useEffect(() => {
        borderTimelineRef.current = gsap.timeline();
        return () => {
            borderTimelineRef.current.clear();
            borderTimelineRef.current = null;
        };
    }, []);

    return (
        <div className="flex gap-6 md:w-48 md:flex-col lg:w-60" ref={logosRef}>
            {logos.map((logo, i) => {
                const isActivated = activeIndex === i;

                return (
                    <Button
                        key={i}
                        className="relative flex min-h-16 w-full items-center justify-center overflow-hidden rounded-md bg-white p-2 transition-opacity duration-500 md:w-auto md:grow md:rounded-2xl md:p-5"
                        style={{ opacity: sortedOpacities[i] }}
                        onClick={() => {
                            if (isActivated) return;
                            animateBrandLogo(timelineRef, logosRef, i, setActiveIndex);
                        }}>
                        <div className="relative size-full">
                            <Image
                                src={getDotcmsImageURL({ src: logo.identifier })}
                                fill
                                sizes="(max-width: 320px) 64px, (max-width: 425px) 90px, 200px"
                                className={`object-contain transition-all duration-1000 ${
                                    !isActivated && 'grayscale'
                                }`}
                                quality={15}
                                alt="brand logo"
                            />
                        </div>
                        <div
                            className={`absolute bottom-0 h-0.5 w-full origin-left bg-green transition-opacity duration-500 ${
                                isActivated ? 'opacity-1' : 'opacity-0'
                            }`}
                        />
                    </Button>
                );
            })}
        </div>
    );
};
